export default function ZehumaPortalContact() {
    return (
        <div className="px-4 py-12 sm:py-16">
            <div className="mx-auto max-w-3xl">
                <h1 className="text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">İletişim</h1>
                <p className="mt-3 text-lg text-slate-600">Zehuma Bilgi Teknolojileri A.Ş.</p>

                <div className="mt-10 space-y-8 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
                    <div>
                        <h2 className="text-xs font-semibold uppercase tracking-wider text-slate-500">Telefon</h2>
                        <a href="tel:08503023545" className="mt-1 block text-lg font-semibold text-violet-700 hover:underline">
                            0850 302 35 45
                        </a>
                    </div>
                    <div>
                        <h2 className="text-xs font-semibold uppercase tracking-wider text-slate-500">E-posta</h2>
                        <a href="mailto:hello@zehuma.com" className="mt-1 block text-lg font-semibold text-violet-700 hover:underline">
                            hello@zehuma.com
                        </a>
                    </div>
                    <div>
                        <h2 className="text-xs font-semibold uppercase tracking-wider text-slate-500">Adres</h2>
                        <p className="mt-1 text-base leading-relaxed text-slate-700">
                            75. Yıl Mah. 5391 Sk. No: 64 D: 3
                            <br />
                            Yunusemre / Manisa
                        </p>
                    </div>
                    <div>
                        <h2 className="text-xs font-semibold uppercase tracking-wider text-slate-500">Çalışma saatleri</h2>
                        <p className="mt-1 text-base text-slate-700">
                            Pazartesi - Cuma: 09:00 - 18:00
                            <br />
                            7/24 Teknik Destek
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
